import { useEffect, useState } from 'react';

import { IUsuario } from '@/@types/Comunidade';
import { ISecaoLab } from '@/@types/Contato/Secoes';
import { SecoesComponent } from '@/components/PagesComponents/Secoes';
import { api } from '@/services/api';

import { useParams } from 'react-router-dom';
import { ContatoEnderecoFeagri } from '@/components/PagesComponents/Secoes/ContatoEnderecoFeagri';

const Secoes = () => {
    const [secaoData, setSecaoData] = useState<ISecaoLab>({} as ISecaoLab); // dados da seção
    const [usuariosSecaoLab, setUsuariosSecaoLab] = useState<IUsuario[]>([]); // usuários da seção
    const [supervisorData, setSupervisorData] = useState<IUsuario>({} as IUsuario); // dados do supervisor/coordenador/chefe da seção

    const { secaoLabId } = useParams(); //id da seção passado por parâmetro na rota

    useEffect(() => {
        // busca os dados da seção por id
        const getSecao = async () => {
            const url = `/feagri/secaolabs/secoes_orgao/${secaoLabId}`

            await api.get<ISecaoLab[]>(url)
                .then(({ data }) => {
                    setSecaoData(data[0]);
                })
                .catch(err => {
                    console.log(err);
                })
        }

        getSecao();
    }, [secaoLabId]);

    useEffect(() => {
        // busca os usuários relacionados á seção por id da seção passado por parâmetro
        const getUsuariosBySecaoId = async () => {
            const url = `/user/register/allSecao/${secaoLabId}`;

            await api.get<IUsuario[]>(url)
                .then(({ data }) => {
                    setUsuariosSecaoLab(data);
                })
                .catch(err => {
                    console.log(err);
                })
        }

        getUsuariosBySecaoId();
    }, [secaoLabId]);

    useEffect(() => {
        const getSupervisorData = async () => {
            // busca os dados do supervisor da seção
            if (secaoData) {
                const url = `/user/register/matricula/${secaoData.secoes_user_matricula}`;

                await api.get<IUsuario[]>(url)
                    .then(({ data }) => {
                        setSupervisorData(data[0]);
                    })
                    .catch(err => {
                        console.log(err);
                    })
            }
        }

        getSupervisorData();
    }, [secaoData]);

    return (
        <div className='md:flex md:justify-between'>
            <SecoesComponent
                secaoData={secaoData}
                supervisorData={supervisorData}
                usuariosSecaoLab={usuariosSecaoLab}
            />

            <ContatoEnderecoFeagri />
        </div>
    );
}

export { Secoes };